<template>
  <div>
    <div class="d-flex justify-content-center height" v-if="project==null">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">در حال بارگذاری ...</span>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-md-12">
        <div class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th>مدیرپروژه</th>
              </tr>
            </thead>
            <tbody>
              <tr class="tr">{{project.manager.name}}</tr>
            </tbody>
          </table>
        </div>
      </div>
      <label class="pt-4 px-3">مدیرپروژه را انتخاب کنید</label>
      <select class="form-control" @change="changeManager($event.target.value)">
        <option value="">مدیرپروژه</option>
        <option v-for="(user, index) in users" :key="index" :value="user.id" :selected="project.manager_id===user.id">{{user.name}}</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  props: ['project', 'users'],
  methods: {
    changeManager (managerId) {
      this.$send.submit('post', 'api/project/manager/' + managerId + '/' + this.$route.params.id)
        .then(response => {
          this.project.manager_id = response.manager_id
          this.project.manager = response.manager
        })
    }
  }
}
</script>

<style>

</style>
